export default "__VITE_ASSET__eac92613__"